import * as React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import Button from "../Button";
import { Error as ErrorIcon } from "../Icons";
const useStyles = makeStyles(({
  palette,
  typography,
  breakpoints
}) => ({
  errorWrapper: {
    alignSelf: "center",
    marginTop: typography.pxToRem(160),
    width: typography.pxToRem(709),
    padding: `${typography.pxToRem(40)} 0 ${typography.pxToRem(40)}`,
    background: palette.background.dialogSecondary,
    [breakpoints.down("xs")]: {
      width: `calc(100% - ${typography.pxToRem(20)})`,
      marginTop: typography.pxToRem(150),
      marginBottom: typography.pxToRem(40)
    }
  },
  errorHeader: {
    width: typography.pxToRem(360),
    fontSize: typography.pxToRem(20),
    letterSpacing: typography.pxToRem(0.19),
    color: palette.text.redWhite,
    textAlign: "center",
    marginBottom: typography.pxToRem(50),
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(14),
      marginBottom: typography.pxToRem(41),
      width: typography.pxToRem(195)
    }
  },
  errorButton: {
    marginTop: typography.pxToRem(60),
    [breakpoints.down("xs")]: {
      marginTop: typography.pxToRem(53)
    }
  }
}));

const ErrorScreen = ({
  title,
  icon: Icon,
  buttonText,
  onClick,
  wrapperClassName
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.errorWrapper, wrapperClassName)
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    direction: "column",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.errorHeader
  }, title), /*#__PURE__*/React.createElement(Icon, null), /*#__PURE__*/React.createElement(Button, {
    className: styles.errorButton,
    onClick: onClick
  }, buttonText)));
};

ErrorScreen.defaultProps = {
  icon: ErrorIcon
};
export default ErrorScreen;